import { SkyButton } from "@skypointcloud/skypoint-ui";
import { AlertCircle } from "lucide-react";

import { IErrorCardProps } from "./commonComponents.interface";

export const ErrorCard = ({
  errorDescription = "Sorry, something went wrong. Try again later",
  showRefreshButton = false,
  refreshButtonText = "Refresh",
  callBackFunctionOnRefresh = () => undefined,
}: IErrorCardProps) => {
  return (
    <div
      className="mt-[20vh] flex flex-col items-center gap-2"
      role="alert"
    >
      <AlertCircle className="w-12 h-12 text-red-500" />
      <span className="text-lg font-semibold">Ooops!</span>
      <span className="text-sm max-w-[390px] text-center">{errorDescription}</span>
      {showRefreshButton ? (
        <SkyButton
          appearance="primary"
          className="mt-4"
          onClick={callBackFunctionOnRefresh}
        >
          {refreshButtonText}
        </SkyButton>
      ) : null}
    </div>
  );
};
